<template>
    <div :style="{ backgroundImage: `url(${backgroundUrl})`, backgroundSize: 'cover' }">
    
        <CCol sm="12" lg="8" class="mx-auto" style="width: 70%; background-size: cover; color: #fff;">
    
            <CCol sm="12" lg="12" style="width: 70%;background-size: cover; margin: auto;color: #fff" class="p-3">
                <CRow class="mt-2 mt-2 ml-3 mr-3">
                    <CCol sm="12" lg="12">
                        <div style="margin-top:15%">
                            <CCard class="b-20 text-black">
                                <CButton type="button" class="btn color-blue text-left" @click="GoToCourse()"> < Back To Previous</CButton>
                           
                                <h3 class="text-black text-left poppin-text mt-4 ml-3">Upload Course</h3>
                                <p class="m-3">
                                Thank you for your interest in adding a new course to our list! Please fill out the following details to provide information about the course.</p>
                                <CCol sm="12" lg="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
                                    <CRow>
                                        <CCol sm="6">
                                            <label class="text-black">Label</label>
                                            <CInput type="text" v-model="Label" placeholder="eg. Bahasa Melayu Tahun 4" />
                                        </CCol>
                                        <CCol sm="6">
                                            <label class="text-black">Topic</label>
                                            <CInput type="text" v-model="Topic" placeholder="eg. Penulisan" />
                                        </CCol>
                                        <CCol sm="12">
                                            <label class="text-black">Synopsis</label>
                                            <CTextarea vertical placeholder="eg. Menjalankan ujian ringkas tatabahasa menggunakan dua set soalan" rows="7" v-model="Synopsis" />
                                        </CCol>
    
                                        <CCol sm="12">
                                            <label class="text-black">Subject</label>
                                            <v-select v-model="SelectedSubject" :options="subjects" label="subjectName" placeholder="--Please Select Subject--" required></v-select>
                                        </CCol>
                                        <CCol sm="12" class="mt-2 mb-2">
                                            <label class="text-black">Teacher</label>
                                                <v-select v-model="SelectedTeacher" :options="teachers" label="name" placeholder="--Please Select Teacher--" required></v-select>
                                         
                                           
    
                                        </CCol>
                                        <CCol sm="6">
                                            <label class="text-black">Category</label>
                                            <CInput type="text" v-model="Category" placeholder="eg. Copywriting" />
                                        </CCol>
                                        <CCol sm="6">
                                            <label class="text-black">Price</label>
                                            <CInput type="number" v-model="Price" placeholder="eg. 12.00" />
                                        </CCol>
    
                                        <CCol sm="12">
                                            <label class="text-dark text-left text-black mt-3">Upload Thumbnail:</label>
                                            <br />
                                            <label class="text-black">Size thumbnail must be width: 272px;height: 145px;</label>
                                            <input type="file" id="thumbnail" ref="mythumbnail" @change="onFileChangeThumbnail" />
    
                                            <div id="preview">
                                                <img style="max-width: 200px" v-if="urlThumbnail" :src="urlThumbnail" />
                                            </div>
                                        </CCol>
                                        <CCol sm="12">
                                        <div v-if="SuccessMessage == true" class="">
                <CAlert show color="success"
                  >Successfully to Save Detail Video</CAlert
                >
              </div>
            </CCol>
    
                                        <div v-if="SubmittedForm === true">
                                            <label>Loading....</label>
                                        </div>
    
                                        <CButton v-else type="button" class="bg-button-blue text-white m-2" block :disabled="isDisabled" @click="InsertVideoData">Submit</CButton>
    
    
                                    </CRow>
                                    <br /><br />
                                </CCol>
                            </CCard>
                            <br /><br />
                        </div>
                    </CCol>
    
    
    
                </CRow>
            </CCol>
            <br /><br /><br />
        </CCol>
    
    
    </div>
</template>
   
   
<script>
import Vue from "vue";
import AOS from "aos";
import "aos/dist/aos.css";

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import Mainlayout from "../containers/AllHeader.vue";
import backgroundUrl from "../assets/img/bgl1.png";

export default {
    name: "App",
    components: {
        Mainlayout
    },
    created() {
        AOS.init();
    },
    data: () => ({
        user: {},
        subjects: [],
        SelectedSubject: "",


        thumbnail: [],

        Label: "",
        Topic: "",
        Price: "",
        Category: "",

        Filename: "",
        Synopsis: "",
        SelectedTeacher: "",
        teachers: [],

        urlThumbnail: null,

        SuccessMessage: false,
        studentProfileAuthorize: {},
        SubmittedForm: false,
        backgroundUrl
    }),
    async mounted() {
        let isAuth = await this.UserAuth();

        if (isAuth) {
            this.Busy = false;
            this.GetInfoUser();
            this.GetSubject();
            this.GetTeacherName();
        } else {
            this.GoToLogin();
        }
    },
    //async mounted() {},
    methods: {
        GoToCourse()
        {
            this.$router.push("AllCourses");
        },
        GetInfoUser() {
            return this.$API
                .get(this.$LoginUserDetail, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.user = response.data;
                        this.GetAuthorizeProfile(this.user.id);
                    }
                });
        },
        GetAuthorizeProfile() {
            this.$API
                .get(this.$PickiddoUserProfile + "?userId=" + this.user.id, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.studentProfileAuthorize = response.data;
                        this.photoURL = this.studentProfileAuthorize.filePath;
                    }
                });
        },
        GetSubject() {
            this.$API
                .get(this.$ListSubject, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.subjects = response.data;
                    }
                });
        },

        GetTeacherName() {
            this.$API
                .get(this.$ListTeacher, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.teachers = response.data;
                    }
                });
        },
        onFileChangeVideo(e) {
            const file = e.target.files[0];
            this.urlVideo = URL.createObjectURL(file);
            this.HandleFileInputVideo();
        },
        HandleFileInputVideo() {
            console.log(this.$refs.myvideo.files);
            this.video = this.$refs.myvideo.files;
            //this.SubmitFileApplicationDescription1();
        },
        onFileChangeThumbnail(e) {
            const file = e.target.files[0];
            this.urlThumbnail = URL.createObjectURL(file);
            this.HandleFileInputThumbnail();
        },
        HandleFileInputThumbnail() {
            console.log(this.$refs.mythumbnail.files);
            this.thumbnail = this.$refs.mythumbnail.files;
            //this.SubmitFileApplicationDescription1();
        },
        onFileChangeBanner(e) {
            const file = e.target.files[0];
            this.urlBanner = URL.createObjectURL(file);
            this.HandleFileInputBanner();
        },
        HandleFileInputBanner() {
            console.log(this.$refs.mybanner.files);
            this.banner = this.$refs.mybanner.files;
            //this.SubmitFileApplicationDescription1();
        },

        InsertVideoData() {
            this.SubmittedForm = true;
            const formData = new FormData();
            formData.append("Label", this.Label);
            formData.append("Topic", this.Topic);
            formData.append("Synopsis", this.Synopsis);
            formData.append("Category", this.Category);
            formData.append("Price", this.Price);
            formData.append("subjectId", this.SelectedSubject.id);

            if (this.SelectedTeacher.teacherId != null) {
                formData.append("TeacherUserId", this.SelectedTeacher.teacherId);
            } else {
                formData.append("TeacherUserId", this.user.id);

            }
            formData.append("thumbnail", this.thumbnail[0]);

            return this.$API
                .post(this.$UploadVideo, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    this.info = response.data;

                    if (response.status == 200) {
                        this.SuccessMessage = true;
                    } else console.log("Error Saving");
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>
       
<style>

</style>
   
   
     